import { ProductsInterface } from '../../../interfaces/dto/products/products-interface';

export class ProductsModel implements ProductsInterface {
  creationTime: string = '';
  digitalArchiveFileId: string = '';
  id: string = '';
  name: string = '';
  productTag: string = '';
  imgUrl: string | undefined;
  featureName?: string = '';
  isDiscontinued?: boolean = true;
  productDescription?: string = '';

  constructor(init?: Partial<ProductsModel>) {
    Object.assign(this, init);
  }
}
